import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Summer/PlaceValue/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PlaceValue',
  field: 'Number',
  weeks: [7, 8],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PlaceValue/1CountFrom50To100" */ './1CountFrom50To100'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year1/Summer/PlaceValue/2TensTo100" */ './2TensTo100')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PlaceValue/3PartitionIntoTensAndOnes" */ './3PartitionIntoTensAndOnes'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PlaceValue/4TheNumberLineTo100" */ './4TheNumberLineTo100'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PlaceValue/5OneMoreOneLess" */ './5OneMoreOneLess'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PlaceValue/6CompareNumbersWithTheSameNumberOfTens" */ './6CompareNumbersWithTheSameNumberOfTens'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PlaceValue/7CompareAnyTwoNumbers" */ './7CompareAnyTwoNumbers'
        )
    })
  ]
});
export default Block;
